"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HumidityAlertState = void 0;
var HumidityAlertState;
(function (HumidityAlertState) {
    HumidityAlertState["NoAlert"] = "NoAlert";
    HumidityAlertState["Alert"] = "Alert";
    HumidityAlertState["LowHumidityAlert"] = "LowHumidityAlert";
    HumidityAlertState["HighHumidityAlert"] = "HighHumidityAlert";
    HumidityAlertState["HumidityCautionAlert"] = "HumidityCautionAlert";
    HumidityAlertState["HumidityHighAlert"] = "HumidityHighAlert";
    HumidityAlertState["HumidityExtremeAlert"] = "HumidityExtremeAlert";
    HumidityAlertState["ServiceRequested"] = "ServiceRequested";
    HumidityAlertState["ServiceScheduled"] = "ServiceScheduled";
    HumidityAlertState["InProgress"] = "InProgress";
})(HumidityAlertState = exports.HumidityAlertState || (exports.HumidityAlertState = {}));
